import EmployeeOffersLetters from "../../../../src/pages/use-cases/page-content/agreements-and-contracts/employee-offer-letters.md";
import * as React from 'react';
export default {
  EmployeeOffersLetters,
  React
};